import {Input, Modal, notification, Result, Space} from "antd";
import {useContext, useState} from "react";
import BMButton, {BMButtonProps} from "../BMButton";
import {useIntl} from "react-intl";
import {ConfiguratorContext} from "../../context";
import {useQuoteContext} from "../../contexts/QuoteContext";

const ReleaseSerialsButton = (props:Omit<BMButtonProps, 'onChange'> & {
    onChange?: () => void
} ) => {

    const [isOpen, setIsOpen] = useState(false);
    const [confirmTxt, setConfirmTxt] = useState<string>();
    const [validationError, setValidationError] = useState<boolean>();

    const { onChange:a, ...btnProps} = props;

    const intl = useIntl();
    const configurator = useContext(ConfiguratorContext);
    const {quote} = useQuoteContext();

    const serialNumberStr = quote?.serialNumberStr;
    const vins = quote?.trucks?.map(t => t.vin).filter(v => !!v) || [];

    const releaseSerials = async () : Promise<boolean> => {
        if ( !quote ) return false;

        try {
            await configurator.api.releaseTrucks(quote.quoteId);
            notification.success({ message: "Serial numbers released." });
            return true;
        } catch (e:any) {
            const errorMsg = intl.formatMessage({ id: e.response?.data.message || e.message });
            notification.error( { message: "Failed to release serial numbers. " + errorMsg });
        }
        return false;
    };

    const handleClick = async () => {
        if ( serialNumberStr && serialNumberStr === confirmTxt?.trim() ) {
            if ( await releaseSerials() ) {
                props.onChange?.();
                setIsOpen(false);
                setConfirmTxt(undefined);
            }
        }
        else {
            setValidationError(true);
        }
    }

    return <>
    <BMButton {...btnProps} onClick={() => setIsOpen(true)} >Release Serial Numbers</BMButton>
    <Modal
        open={isOpen}
        okText="Release"
        okButtonProps={{danger: true}}
        onOk={handleClick}
        onCancel={() => setIsOpen(false)}
        centered
    >
        <Result
            status="warning"
            title="Releasing Serial Numbers"
        >
            <Space direction={"vertical"} style={{width: "100%"}}>
                <div>The serial numbers and VINs below will be removed from this quote and returned to the pool. Serials below the current highest serial are not reissued automatically.</div>
                <div style={{fontStyle: "italic", fontWeight: "bold", textAlign: "center"}} data-testid="release-serials-range">{serialNumberStr}</div>
                { vins.length > 0 &&
                    <div style={{textAlign: "center", fontFamily: "monospace"}}>{vins.map(v => <div key={v}>{v}</div>)}</div>}
                <div>Please type the serial number range to confirm:</div>
                <div><Input data-testid="release-serials-confirm" value={confirmTxt} onChange={(e) => {
                    setConfirmTxt(e.target.value);
                    setValidationError(false);
                }} /></div>
                { validationError &&
                    <div style={{color: "#ff4d4f"}} >Does not match the serial number range.</div>}
            </Space>
        </Result>
    </Modal>
    </>
}

export default ReleaseSerialsButton;
